/* src/app/modules/shared/components/column/column-badge/column-badge.component.scss */
app-column-badge {
  display: contents;
}
/*# sourceMappingURL=column-badge.component.css.map */
